import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { Link } from "react-scroll";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import styles from "./Navbar.module.css"

export default function AccountMenu() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    const theme = createTheme({
        typography: {
            fontFamily: 'Poppins, sans-serif',
            fontSize: 15,
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <React.Fragment>
                <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', width: 400 }}>
                    <Tooltip title="Account settings">
                        <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
                            <Avatar sx={{ width: 30, height: 30, color: "black", backgroundColor: "#64AAFF" }}>M</Avatar>
                        </IconButton>
                    </Tooltip>
                </Box>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&:before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <Link to="Home" smooth={true} spy={true} duration={1000}>
                        <MenuItem >
                            Home
                        </MenuItem>
                    </Link>

                    <Link to="About me" smooth={true} spy={true} duration={1000}>
                        <MenuItem>
                            About me
                        </MenuItem>
                    </Link>

                    <Link to="Projects" smooth={true} spy={true} duration={1000}>
                        <MenuItem>
                            Projects
                        </MenuItem>
                    </Link>

                    <Link to="Skills" smooth={true} spy={true} duration={1000}>
                        <MenuItem>
                            Skills
                        </MenuItem>
                    </Link>

                    <Link to="Contact" smooth={true} spy={true} duration={1000}>
                        <MenuItem>
                            Contact
                        </MenuItem>
                    </Link>

                    <MenuItem>
                        <button className={styles.MenuButton}>
                            <a href="./Pratik.pdf" download="Pratik.pdf">
                                RESUME
                            </a>
                        </button>
                    </MenuItem>
                </Menu>
            </React.Fragment>
        </ThemeProvider>
    );
}